import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  CHECKPOINT_MS,
  moduleNameFor,
  startSession,
  checkpoint,
  endSession,
  recoverAbandonedSession,
  flushQueue,
} from "../../../../utils/analytics/timeTracking";

function TimeTracking() {
  const location = useLocation();
  // A ref, not state: a click should not re-render the whole page tree.
  const clicksRef = useRef(0);

  useEffect(() => {
    // Anything left open belongs to a session that ended without a navigation.
    recoverAbandonedSession();
    flushQueue();
  }, []);

  useEffect(() => {
    startSession(moduleNameFor(location.pathname));
    clicksRef.current = 0;

    const checkpointTimer = setInterval(() => {
      checkpoint(clicksRef.current);
    }, CHECKPOINT_MS);

    return () => {
      clearInterval(checkpointTimer);
      endSession(clicksRef.current);
      flushQueue();
    };
  }, [location.pathname]);

  useEffect(() => {
    const countClick = () => {
      clicksRef.current += 1;
    };
    window.addEventListener("click", countClick);
    return () => {
      window.removeEventListener("click", countClick);
    };
  }, []);

  useEffect(() => {
    // visibilitychange rather than beforeunload: it is the only one that fires
    // reliably on tab switch, backgrounding and screen lock on mobile Safari
    // and Android, which is what these tablets run.
    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        checkpoint(clicksRef.current);
        flushQueue({ keepalive: true });
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return null;
}

export default TimeTracking;
